import styled from 'theme';

export const ContentBackground = styled('div')`
  position: relative;
  width: 100%;
  background-color: ${(p) => p.theme.colors.gray100};
  flex: auto;
`;
